module.exports = __webpack_public_path__ + "static/media/hn-ba-dinh.7f29ea80.svg";